module.exports = __webpack_public_path__ + "static/media/headphones.911eb1f2.svg";